import { getCentsValue, getDollarValue } from "../../helpers/currency";
import { formatAmountWithThousandsSeparators, getDecimalSeparator } from "./numbers";
export const stripGroupSeparators = (value, locale) => {
    const withoutSpaces = value.replace(/[\s\u00A0\u202F]/g, "");
    return getDecimalSeparator(locale) === ","
        ? withoutSpaces.replace(/\.(?=\d{3})/g, "")
        : withoutSpaces.replace(/,(?=\d{3})/g, "");
};
export const unformatDisplayValue = (value, locale) => stripGroupSeparators(value, locale).replace(",", ".");
export const sanitizeAmountInput = (value) => value.replace(/[^\d.,\s\u00A0\u202F]/g, "");
export const formatDisplayValue = (value, locale) => {
    const numericValue = parseFloat(unformatDisplayValue(value, locale));
    if (!isFinite(numericValue)) {
        return value;
    }
    return formatAmountWithThousandsSeparators(numericValue, locale);
};
export const formatCentsToEditableValue = (cents, locale) => getDollarValue(cents).toString().replace(".", getDecimalSeparator(locale));
export const parseDefaultDisplayValue = (value, locale) => {
    if (value === 0) {
        return "0";
    }
    if (value) {
        return formatDisplayValue(getDollarValue(value).toString(), locale);
    }
    return "";
};
export const parseInputValue = (value, locale) => {
    // Check if value is too large to be safely handled
    const MAX_SAFE_AMOUNT = 10000000000; // $999,999,999,999.99
    const numericValue = parseFloat(unformatDisplayValue(value, locale));
    if (numericValue > MAX_SAFE_AMOUNT) {
        return MAX_SAFE_AMOUNT;
    }
    const parsedValue = getCentsValue(numericValue);
    return isNaN(parsedValue) || parsedValue === null ? null : Math.round(parsedValue);
};
